// client/src/components/ui/Modal/Modal.js
import React from 'react'

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  hideDefaultButtons = false,
}) => {
  if (!isOpen) return null

  return (
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">{children}</div>
          {!hideDefaultButtons && (
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Modal
